// extracted by mini-css-extract-plugin
export default {"loaderMainContainer":"styles_loaderMainContainer__0I2JV","loaderContainer":"styles_loaderContainer__1vkHA","loader":"styles_loader__-i2n3","spin":"styles_spin__EWP4w"};